import React from 'react';
import { FormControl } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import PillInput from '../../../common/pill_input/main';

export default class CustomFieldKeyConfiguration extends React.Component {
  get name() {
    return this.props.name;
  }

  get allowedValues() {
    return this.props.allowedValues;
  }

  updateName(event) {
    let name = event.target.value;
    let allowedValues = this.allowedValues;
    let { index } = this.props;
    this.props.updateCustomField(index, name, allowedValues);
  }

  updateAllowedValues(pillState) {
    let name = this.name;
    let allowedValues = pillState.pills;
    let { index } = this.props;
    this.props.updateCustomField(index, name, allowedValues);
  }

  removeCustomField() {
    this.props.removeCustomField(this.props.index);
  }

  componentDidMount() {
    ReactDOM.findDOMNode(this.refs.nameInput).focus();
  }

  render() {
    return (
      <div className="brandfolder-settings__control-custom-fields--list-item">
        <div className="one-third-width">
          <FormControl
            ref="nameInput"
            id="name"
            name="name"
            style={{ borderColor: this.props.valid ? "grey" : "red" }}
            className="custom-field-input"
            type="text"
            placeholder={t("Key")}
            value={this.name}
            onChange={event => this.updateName(event)}
          />
        </div>
        <div className="two-thirds-width">
          <PillInput
            id="allowed_values"
            name="allowed_values"
            className="custom-field-input"
            type="text"
            placeholderText={t("Enter values (comma-separated)")}
            pills={this.allowedValues}
            onChangeCallback={pillState => this.updateAllowedValues(pillState)}
          />
          <span
            className="remove-control-custom-field bff-trash"
            onClick={() => this.removeCustomField()}
            role="button"
          />
        </div>
      </div>
    );
  }
}
